import React from "react";
import ResumeCard from "../../shared/resumeCard/ResumeCard";
import { Link } from 'react-router-dom'
import Button from "../../shared/button/Button";
import './Resume.css'
import pdf from '../../static/EKWUNIFE-FIDELIS.pdf'

const Resume = () => {
    const experiences = [
        {
            company: "Flipeet",
            position: "Blockchain Developer",
            started: "september 2022",
            ended: null,
            description: "An NFT Marketplace",
            achievements: [
                "Enhanced API Performance: Optimized the RESTful API endpoints, reducing response times by best possible time complexity and improving overall system efficiency, resulting in a better user experience",
                "Implemented Scalable Backend Architecture: Designed and developed a scalable backend architecture to handle the increasing user traffic on the Flipeet platform, resulting in improved performance and stability.",
                "Built and Maintained Microservices: Developed and maintained a microservices-based architecture, ensuring seamless communication and scalability among different services, resulting in improved development efficiency and modular codebase.",
                "Implemented Real-Time Notifications: Integrated WebSocket technology to provide real-time notifications for users on the Flipeet platform, improving user engagement and enhancing the platform's interactive features.",
                "Resolved Critical Production Issues: Successfully resolved critical production issues, such as performance bottlenecks or system failures, in a timely manner, minimizing downtime and ensuring a smooth user experience"
            ]
        },
        {
            company: "BlueTag Technologies",
            position: "Backend Developer",
            started: "september 2021",
            ended: "August 2022",
            description: "A software development firm",
            achievements: [
                "Integrated Third-Party Services and APIs: Integrated various third-party services and APIs into backend systems, enabling seamless functionality such as payment gateways, social media integrations, or external data sources, expanding the capabilities of the software solution.",
                "Mentored Junior Developers: Acted as a mentor to junior developers, providing guidance, support, and knowledgesharing sessions, contributing to the growth and development of the team and fostering a collaborative learning environment.",
                "Implemented Security Measures: Implemented strong authentication and authorization mechanisms, data encryption techniques, and other security measures to protect user data and prevent unauthorized access, ensuring compliance with security standards and regulations.",
                "Resolved Complex Technical Challenges: Successfully resolved complex technical challenges and issues, and optimization techniques, ensuring stable and reliable backend systems."
            ]
        },
        {
            company: "Nigerian Breweries PLC",
            position: "Backend Developer",
            started: "December 2020",
            ended: "August 2021",
            description: "A beverage industry",
            achievements: [
                "Continuous Learning and Technological Advancement: Demonstrated a commitment to continuous learning, staying updated with the latest trends, technologies, and best practices in backend development, proactively incorporating new tools, frameworks, or methodologies to improve efficiency and deliver cutting-edge solutions.",
                "Build and maintain robust systems and infrastructure to support its operations. This includes developing scalable backend architecture, implementing data processing solutions, integrating third-party systems, and ensuring high levels of security and performance."
            ]
        },
        {
            company: "TheAlgorithms/Solidity",
            position: "Contributor",
            started: "september 2022",
            ended: null,
            description: "An open source project for all algorithms implemented in Solidity ",
            achievements: [
                "I added Binary search Algorithm which has a timecomplexity of O(LogN). It is a search algorithm that finds the position of a target value within a sorted array and it compares the target value to the middle element of the array. If they are not equal, the half in which the target cannot lie is eliminated and the search continues on the remaining half.",
                "solved open issue for the growth of the community"
            ],
        },
    ]

    const skills = [
        {
            title: 'Languages',
            body: ['JAVASCRIPT', 'SOLIDITY', 'ASP.NET Core', 'Python']
        },
        {
            title: 'Database',
            body: ['MONGODB', 'BLOCKCHAIN', 'POSTGRES', 'MySQL']
        },
        {
            title: 'Technologies',
            body: ['DOCKER', 'NODE JS', 'KAFKA', 'EXPRESS JS', 'WEB3 JS', 'NEST JS', 'POSTGRES', 'MySQL', 'POSTMAN', 'GIT']
        }
    ]

    return (
        <div className="resume">
            <div className="resume_container">
                <div className="top_row">
                    <h1>Fidelis Chiadikaobi</h1>
                    <div className="buttons">
                        <a
                            href="https://www.linkedin.com/in/chiadikaobixo/"
                        >
                            <small>
                                <i className="fab fa-linkedin"></i> <span>Linked In</span>
                            </small>
                        </a>
                        <a
                            href={pdf}
                        >
                            <small>
                                <i className="fas fa-download"></i> <span>Download </span>
                            </small>
                        </a>
                    </div>
                </div>
                <p>Backend Engineer </p>
                <div className="summary">
                    <p>
                        A <span className="highlight">backend</span> developer with expertise in <span className="highlight">Node.js, Typescript
                        </span> and <span className="highlight">Solidity</span> with four years of technical experience. I write
                        web2 and web3 powered applications. I have strong problem-solving 
                        abilities and I create efficient and scalable software solutions. 
                        Highly experienced in both <span className="highlight">microservice</span> and 
                        <span className="highlight"> monolithic architecture </span> 
                        with expertise in various service communication strategies including 
                        <span className="highlight"> RESTful API, gRPC, GraphQL,</span> and <span className="highlight">WebSocket</span>. Conversant with <span className="highlight">Nestjs</span> and <span className="highlight">Express</span> and knowledge of <span className="highlight">Cloud Computing</span> using <span className="highlight">AWS</span>, proficient in designing
                        and developing scalable software solutions using different technologies. 
                        Committed to following industry bestpractices and adhering to the <span className="highlight">SOLID principles </span>
                        of software design. Proven track record of delivering high-quality code
                        and working collaboratively in agile development environments.
                    </p>
                </div>
                <div className="divider">
                    <p>stacks</p>
                    <span></span>
                </div>
                <div className="skills">
                    {
                        skills.map((skill, index) => (
                            <p key={index} id={index}>
                                <span className="highlight" >{skill.title} </span>
                                <span>:{" "}{skill.body.map((value) => `${value}. `)}</span>
                            </p>
                        ))
                    }
                </div>
                <div className="divider">
                    <p>Experience</p>
                    <span></span>
                </div>
                <div>
                    {
                        experiences.map((experience, index) => (
                            <ResumeCard {...experience} key={index} id={index} />))
                    }
                </div>
                <div className="divider">
                    <p>Proficiency in:</p>
                    <span></span>
                </div>
                <div className="skills">
                    <span><p>■{" "}English</p></span>
                </div>
                <div className="divider">
                    <p>Projects</p>
                    <span></span>
                </div>
                <div className="exp_container">
                    <section className="experience">
                        <article className="description">
                            <p className="nospan">
                                Links to my works can be found on {" "}
                                <Link to="/project">Projects</Link>
                            </p>
                        </article>
                    </section>
                </div>
            </div>
            <Button
                previous={{ url: '/article', text: 'Article' }}
                next={{ url: '/', text: 'Home' }}
            />
        </div>
    )
}

export default Resume